import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Row, Col, Button, Alert, FloatingLabel, Form, Card} from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import logo from '../../assets/logo.png'

// Actions
import { iniciarSesionAction, enviaCodigoVerificacion, cambiarPassword } from '../../store/actions/login-action';

const SignIn = (props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [allValues, setAllValues] = useState({ user: '', password: '', codigo: '', newpassword: '' });
    const [allErrors, setAllErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageChange, setErrorMessageChange] = useState("");
    const [succesMessageChange, setSuccesMessageChange] = useState("");
    const [show, setShow] = useState(false)

    const handleChange = (e) => {
        const { id, value } = e.target;
        
        setAllErrors((prevValues) => {
            return { ...prevValues, [id]: "" }
        });

        setAllValues((prevValues) => {
          return { ...prevValues, [id]: value }
        });
    };

    const validateForm = () => {
    
        var errors = {}
    
        if (!allValues.user) {
          errors.user = 'Debe ingresar el nombre de usuario';
        }
    
        if (!allValues.password) {
          errors.password = 'Debe ingresar la contraseña';
        }
    
        setAllErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const handleSignIn = () => {

        var isValid = validateForm();

        if (isValid) {

            let data = btoa(JSON.stringify(allValues));
            dispatch(iniciarSesionAction(data)).then((result) => {

                if (result.payload.message) {

                    setErrorMessage(result.payload.message);

                } else {

                    props.onSuccess();
                    navigate("/");
                }

            }).catch((error) => {

                console.error(error);
            });
        }
    }
    const recuperarContrasenia = () => {
        if (!allValues.user) {
            var errors = {}
            errors.user = 'Debe ingresar el nombre de usuario';
            setAllErrors(errors);
        } else {
            let data = allValues;
            data.accion=1;
            let query = Buffer.from(JSON.stringify(data)).toString('base64');
            dispatch(enviaCodigoVerificacion(query)).then((result) => {
                if (result.payload.message) {
                    setErrorMessage(result.payload.message);
                } else {
                    handleShow();
                }
            }).catch((error) => {
                console.error(error);
            });
        }
    }
    const enviar = () => {
        var isValid = validateModal();
        if (isValid) {
            let data = allValues;
            data.accion=2;
            let query = Buffer.from(JSON.stringify(data)).toString('base64');
            dispatch(cambiarPassword(query)).then((result) => {
                if (result.payload.message) {
                    setErrorMessageChange(result.payload.message);
                } else {
                    setSuccesMessageChange(result.payload.data.message);
                    setTimeout(()=> handleClose(),3000)
                }
            }).catch((error) => {
                console.error(error);
            });
        }
    }
    const validateModal = () => {
    
        var errors = {}
    
        if (!allValues.codigo) {
            errors.codigo = 'Debe ingresar código verificación';
        }
    
        if (!allValues.newpassword) {
          errors.newpassword = 'Debe nueva contraseña';
        }
        setAllErrors(errors);
        return Object.keys(errors).length === 0;
    }
    const handleClose = () => {  
        setShow(false)
    }
    const handleShow = () => {  
        allValues.codigo="";
        allValues.newpassword="";
        setErrorMessageChange("");
        setSuccesMessageChange("");
        setShow(true)
    }
    return (
        <>
            <Form className="form-signin">
                <img className="img-thumbnail mb-4 w-100" src={logo} alt="Recupero & Defensa"></img>
                {/*<h1 className="h3 mb-3 fw-normal">Recupero & Defensa</h1>*/}
                <Alert className="mb-3" variant="danger" show={errorMessage!==""} onClose={() => { setErrorMessage("") }} dismissible>{errorMessage}</Alert>
                <FloatingLabel controlId="user" label="Usuario" className="mb-3">
                    <Form.Control type="user" placeholder="Ingrese nombre de usuario" onChange={ (e) => { handleChange(e) } } isValid={allValues.user ? true : false } isInvalid={allErrors.user ? true : false } />
                    <Form.Control.Feedback style={{'display':'block'}} className="text-start" type="invalid">{allErrors.user}</Form.Control.Feedback>
                </FloatingLabel>
                <FloatingLabel controlId="password" label="Contraseña" className="mb-3">
                    <Form.Control type="password" placeholder="Ingrese contraseña" onChange={ (e) => { handleChange(e) } } isValid={allValues.password ? true : false } isInvalid={allErrors.password ? true : false } />
                    <Form.Control.Feedback style={{'display':'block'}} className="text-start" type="invalid">{allErrors.password}</Form.Control.Feedback>    
                </FloatingLabel>
                <Button className="w-100" size="lg" variant="primary" type="button" onClick={handleSignIn}>Ingresar</Button>
                <Button className="mt-3" variant="link" onClick={recuperarContrasenia}>¿Olvidaste tu clave de acceso?</Button>
                <p className="mt-3 mb-3 text-muted">© 2026</p>
            
                <Modal show={show} onHide={handleClose} dialogClassName="modal-90w">
                    <Card>
                        <Card.Header className='mt-0 mb-0' as='h6' style={{ textAlign:'center', backgroundColor: '#4F517A', color: 'white' }}>
                            Cambio de Contraseña
                        </Card.Header>
                        <Card.Body>
                            <Row className="show-grid">
                                <Col md='12'>
                                    Se envió a su correo un código de verificación para el cambio de contraseña.
                                    Favor ingrese código y nueva contraseña.
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='d-flex flex-row'>                                            
                                        <hr style={{color: '#04005D',height: '0px',width:'100%',marginTop: '20px'}}></hr>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="show-grid">
                                <Col md='12'>
                                    <Alert className="mb-3" variant="danger" show={errorMessageChange!==""} onClose={() => { setErrorMessageChange("") }} dismissible>{errorMessageChange}</Alert>
                                </Col>
                            </Row>
                            <FloatingLabel controlId="codigo" label="Código" className="mb-3">
                                <Form.Control type="text" placeholder="Ingrese código verificación" onChange={ (e) => { handleChange(e) } } isValid={allValues.codigo ? true : false } isInvalid={allErrors.codigo ? true : false } />
                                <Form.Control.Feedback style={{'display':'block'}} className="text-start" type="invalid">{allErrors.codigo}</Form.Control.Feedback>
                            </FloatingLabel>            
                            <FloatingLabel controlId="newpassword" label="Nueva Contraseña" className="mb-3">
                                    <Form.Control type="text" placeholder="Ingrese nueva contraseña" onChange={ (e) => { handleChange(e) } } isValid={allValues.newpassword ? true : false } isInvalid={allErrors.newpassword ? true : false } />
                                    <Form.Control.Feedback style={{'display':'block'}} className="text-start" type="invalid">{allErrors.newpassword}</Form.Control.Feedback>
                            </FloatingLabel>         
                            <Row className="show-grid">
                                <Col md='12'>
                                    <Alert className="mb-3" variant="primary" show={succesMessageChange!==""} onClose={() => { setSuccesMessageChange("") }} dismissible>{succesMessageChange}</Alert> 
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer style={{ alignContent:'center', display: 'flex', justifyContent: 'end' }}>
                            <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}>Cerrar</Button>
                            <Button className='m-2 w-auto' variant='primary' onClick={enviar}>Enviar</Button>
                        </Card.Footer>
                    </Card>                
                </Modal>
            </Form>
        </>
    )
}

export default SignIn;